'use strict';

var FaresSurchargeUploadErrorLogController = function FaresSurchargeUploadErrorLogController($scope, featureToggleService) {
  var height = 24;
  var errorRowClass = 'error';
  function getRowClass(params) {
    if (!params.data.valid) {
      return errorRowClass;
    }
  }
  var columnDef = [{
    headerName: 'Row',
    field: 'rowId',
    width: 45
  }, {
    headerName: 'Orig',
    field: 'marketOrigin',
    width: 200
  }, {
    headerName: 'Dest',
    field: 'marketDestination',
    width: 200
  }, {
    headerName: 'Eff Date',
    field: 'begin',
    width: 200
  }, {
    headerName: 'Disc Date',
    field: 'end',
    width: 200
  }, {
    headerName: 'Class',
    field: 'fareClass',
    width: 200
  }, {
    headerName: 'Surcharge',
    field: 'surcharge',
    width: 200
  }, {
    headerName: '',
    field: 'emptyColumn',
    width: 280
  }];
  function intializeErrorGrid() {
    $scope.gridOptions = {
      columnDefs: undefined,
      rowData: $scope.errorLogData,
      rowClass: getRowClass,
      headerHeight: height,
      rowHeight: height,
      suppressRowClickSelection: true,
      suppressCellSelection: true
    };
    if (featureToggleService.isEnabled('FIM') && featureToggleService.isEnabled('SPOS')) {
      columnDef.splice(6, 0, {
        headerName: 'POS',
        field: 'spos',
        width: 200
      });
    }
    $scope.gridOptions.columnDefs = columnDef;
  }
  $scope.closeErrorLog = function () {
    $scope.$emit('fares-surcharge-upload:errorLogClose');
  };
  intializeErrorGrid();
};
FaresSurchargeUploadErrorLogController.$inject = ['$scope', 'FeatureToggleService'];
module.exports = FaresSurchargeUploadErrorLogController;